import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class NotificationList extends DexResourceModel {

    @Field(String)
    public userId: string | null = null;
 
    @Field(String)
    public emailTo: string | null = null;

    @Field(String)
    public emailCC: string | null = null;

    @Field(String)
    public emailBCC: string | null = null;

    /** Replaced with deliveredAt */
    @Field(Date)
    public emailedAt: Date | null = null;

    @Field(Date)
    public viewedAt: Date | null = null;

    @Field(String)
    public notificationTypeId: string = "";

    @Field(String)
    public subject: string | null = null;

    @Field(String)
    public contentText: string | null = null;

    @Field(String)
    public contentHtml: string | null = null;

    @Field(String)
    public jsonData: string | null = null;

    @Field(Date)
    public deliveredAt: Date | null = null;

    @Field(String)
    public deliveryStatusResponse: string | null = null;

    // REMOVED: duplicate of deliveredVia
    // @Field(String)
    // public deliverVia: 'SES' | 'MailGun' = 'MailGun';

    @Field(String)
    public deliveredVia: 'SES' | 'MailGun' | null = null;

    @Field(Boolean)
    public deliveredBrowserPushNotification: boolean = false;

    @Field(String)
    public objectType: string | null = null;
    
    @Field(String)
    public internal_uuid: string | null = null;

    @Field(String)
    public email?: string | null = null;

    @Field(String)
    public firstName?: string | null = null;

    @Field(String)
    public lastName?: string | null = null;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }

}